import React from 'react'
import { Typography, makeStyles } from '@material-ui/core'
import { Box, Link } from '@mui/material'
import { WarningRounded } from '@material-ui/icons'
import { MeetCSympleTeamEmail } from 'constants/index'
const PageNotFound = () => {
  const classes = useStyles()
  return (
    <Box className={classes.notFound}>
      <WarningRounded className={classes.cancel} />
      <Box>
        <Typography className={classes.errMsg}>
          The page you&apos;re trying to reach is no longer available. There could be different
          reasons like below:
        </Typography>
        <Box className={classes.msgBox}>
          <Box>
            <Typography className={classes.errMsg}>
              1. You may be using wrong URL. Please verify URL and try again.
            </Typography>
            <Typography className={classes.errMsg}>
              2. The conference has already concluded and is no longer active.
            </Typography>
          </Box>
        </Box>
        <Typography className={classes.errText}>
          For more information contact us at{' '}
          <Link href={`mailto:${MeetCSympleTeamEmail}`}>{MeetCSympleTeamEmail}</Link>
        </Typography>
      </Box>
    </Box>
  )
}

export default PageNotFound

const useStyles = makeStyles({
  notFound: {
    marginTop: '5rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  cancel: {
    color: '#ffa726',
    fontSize: '125px'
  },
  msgBox: {
    marginTop: '10px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  errHead: {
    fontSize: '16px'
  },
  errMsg: {
    fontSize: '16px'
  },
  errText: {
    marginTop: '0.5rem',
    fontSize: '16px'
  }
})
